import React from "react";
import { useIsSmallScreen } from "../../App";
import { PSALMS_1928 } from "../../chants/data-1928";
import { Padding } from "../../shared-components/Padding";
import { TEXT_COLOR, TEXT_INDENT, TEXT_SIZE } from "../../tokens";
import { Rubric } from "../pray/Rubric";
import { Spacer } from "../pray/Spacer";
import { TextBlock } from "../pray/TextBlock";
import { TextLine } from "../pray/TextLine";

export const ComminationPage: React.FC<{}> = () => {
    const isSmallScreen = useIsSmallScreen();

    return (
        <>
            <Padding>
                <div
                    style={{
                        fontWeight: "bold",
                        letterSpacing: 2,
                        textTransform: "uppercase",
                        fontSize: "140%",
                        paddingBottom: 4,
                        paddingTop: 32,
                        textAlign: "center",
                    }}
                >
                    The Commination
                </div>
            </Padding>
            <Rubric content="The Officiant shall say," />
            <TextBlock
                content="Brethren, in the Primitive Church there was a godly discipline,
                that, at the beginning of Lent, such persons as stood convicted
                of notorious sin were put to open penance, and punished in this
                world, that their souls might be saved in the day of the Lord;
                and that others, admonished by their example, might be the more
                afraid to offend.\n\nInstead whereof, until the said discipline may be restored
                again, (which is much to be wished,) it is thought good, that at
                this time (in the presence of you all) should be read the
                general sentences of God's cursing against impenitent sinners,
                gathered out of the seven and twentieth Chapter of Deuteronomy,
                and other places of Scripture; and that ye should answer to
                every Sentence, Amen: To the intent that, being admonished of
                the great indignation of God against sinners, ye may the rather
                be moved to earnest and true repentance; and may walk more
                warily in these dangerous days; fleeing from such vices, for
                which ye affirm with your own mouths the curse of God to be due."
            ></TextBlock>
            <Spacer />
            <Rubric content="The Officiant shall say, the_People_responding," />
            <TextBlock
                content="Cursed is the man that maketh any carved or molten image, to
                worship it.\n
                **Amen.**\n\n
                Cursed is he that curseth his father or mother.\n
                **Amen.**\n\n
                Cursed is he that removeth his neighbour's landmark.\n
                **Amen.**\n\n
                Cursed is he that maketh the blind to go out of his way.\n
                **Amen.**\n\n
                Cursed is he that perverteth the judgement of the stranger, the
                fatherless, and widow.\n
                **Amen.**\n\n
                Cursed is he that smiteth his neighbour secretly.\n
                **Amen.**\n\n
                Cursed is he that lieth with his neighbour's wife.\n
                **Amen.**\n\n
                Cursed is he that taketh reward to slay the innocent.\n
                **Amen.**\n\n
                Cursed is he that putteth his trust in man, and taketh man for
                his defence, and in his heart goeth from the Lord.\n
                **Amen.**\n\n
                Cursed are the unmerciful, fornicators, and adulterers, covetous
                persons, idolaters, slanderers, drunkards, and extortioners.\n
                **Amen.**"
            ></TextBlock>
            <Spacer />
            <Rubric content="The Officiant shall continue," />
            <TextBlock
                content="Now seeing that all they are accursed (as the prophet David
                beareth witness) who do err and go astray from the commandments
                of God; let us (remembering the dreadful judgement hanging over
                our heads, and always ready to fall upon us) return unto our
                Lord God, with all contrition and meekness of heart; bewailing
                and lamenting our sinful life, acknowledging and confessing our
                offences, and seeking to bring forth worthy fruits of penance.
                For now is the axe put unto the root of the trees, so that every
                tree that bringeth not forth good fruit is hewn down, and cast
                into the fire. It is a fearful thing to fall into the hands of
                the living God: he shall pour down rain upon the sinners,
                snares, fire and brimstone, storm and tempest; this shall be
                their portion to drink. For lo, the Lord is come out of his
                place to visit the wickedness of such as dwell upon the earth.
                But who may abide the day of his coming? Who shall be able to
                endure when he appeareth? His fan is in his hand, and he will
                purge his floor, and gather his wheat into the barn; but he will
                burn the chaff with unquenchable fire. The day of the Lord
                cometh as a thief in the night: and when men shall say, Peace,
                and all things are safe, then shall sudden destruction come upon
                them, as sorrow cometh upon a woman travailing with child, and
                they shall not escape. Then shall appear the wrath of God in the
                day of vengeance, which obstinate sinners, through the
                stubbornness of their heart, have heaped unto themselves; which
                despised the goodness, patience, and long-sufferance of God,
                when he calleth them continually to repentance. Then shall they
                call upon me, (saith the Lord,) but I will not hear; they shall
                seek me early, but they shall not find me; and that, because
                they hated knowledge, and received not the fear of the Lord, but
                abhorred my counsel, and despised my correction. Then shall it
                be too late to knock when the door shall be shut; and too late
                to cry for mercy when it is the time of justice. O terrible
                voice of most just judgement, which shall be pronounced upon
                them, when it shall be said unto them, Go, ye cursed, into the
                fire everlasting, which is prepared for the devil and his
                angels. Therefore, brethren, take we heed betime, while the day
                of salvation lasteth; for the night cometh, when none can work.
                But let us, while we have the light, believe in the light, and
                walk as children of the light; that we be not cast into utter
                darkness, where is weeping and gnashing of teeth. Let us not
                abuse the goodness of God, who calleth us mercifully to
                amendment, and of his endless pity promiseth us forgiveness of
                that which is past, if with a perfect and true heart we return
                unto him. For though our sins be as red as scarlet, they shall
                be made white as snow; and though they be like purple, yet they
                shall be made white as wool. Turn ye (saith the Lord) from all
                your wickedness, and your sin shall not be your destruction:
                Cast away from you all your ungodliness that ye have done: Make
                you new hearts, and a new spirit: Wherefore will ye die, O ye
                house of Israel, seeing that I have no pleasure in the death of
                him that dieth, saith the Lord God? Turn ye then, and ye shall
                live. Although we have sinned, yet have we an Advocate with the
                Father, Jesus Christ the righteous; and he is the propitiation
                for our sins. For he was wounded for our offences, and smitten
                for our wickedness. Let us therefore return unto him, who is the
                merciful receiver of all true penitent sinners; assuring
                ourselves that he is ready to receive us, and most willing to
                pardon us, if we come unto him with faithful repentance; if we
                submit ourselves unto him, and from henceforth walk in his ways;
                if we will take his easy yoke, and light burden upon us, to
                follow him in lowliness, patience, and charity, and be ordered
                by the governance of his Holy Spirit; seeking always his glory,
                and serving him duly in our vocation with thanksgiving: This if
                we do, Christ will deliver us from the curse of the law, and
                from the extreme malediction which shall light upon them that
                shall be set on the left hand; and he will set us on his right
                hand, and give us the gracious benediction of his Father,
                commanding us to take possession of his glorious kingdom: Unto
                which he vouchsafe to bring us all, for his infinite mercy.
                Amen."
            />
            <Spacer />
            <Rubric content="All kneeling, this **Penitential_Psalm** (Psalm_51) shall_be_said_without_note." />
            <Padding onlySides>
                <div
                    style={{
                        paddingBottom: 8,
                        paddingTop: 8,
                        paddingLeft: isSmallScreen
                            ? TEXT_INDENT / 2
                            : TEXT_INDENT,
                        paddingRight: isSmallScreen
                            ? TEXT_INDENT / 2
                            : TEXT_INDENT,
                        fontSize: isSmallScreen ? TEXT_SIZE * 0.9 : TEXT_SIZE,
                        textAlign: "justify",
                        color: TEXT_COLOR,
                    }}
                >
                    <div
                        style={{
                            whiteSpace: "pre-wrap",
                            textAlign: "justify",
                        }}
                    >
                        {PSALMS_1928.find(
                            (psalm) => psalm.id === "psalm51"
                        )?.lines.map((line) => {
                            return (
                                <>
                                    <TextLine>
                                        {line[0]
                                            .replace(/_/g, "")
                                            .replace(/\//g, "")}
                                    </TextLine>
                                    <TextLine indent={1}>
                                        {line[1]
                                            .replace(/_/g, "")
                                            .replace(/\//g, "")}
                                    </TextLine>
                                </>
                            );
                        })}
                    </div>
                </div>
            </Padding>

            <Spacer />

            <Rubric content="The Officiant shall pray, the_People_responding," />
            <TextBlock content="Lord, have mercy upon us.\n**Christ, have mercy upon us.**\n**Lord, have mercy upon us.**" />

            <TextBlock
                content="Our Father, who art in heaven, Hallowed be thy Name. Thy kingdom
                come. Thy will be done on earth, as it is in heaven. Give us
                this day our daily bread, And forgive us our trespasses, As we
                forgive them that trespass against us. And lead us not into
                temptation; But deliver us from evil. For thine is the kingdom,
                the power, and the glory, for ever and ever.\n**Amen.**"
            />

            <TextBlock
                content="O Lord, save thy servants;\n
            **That put their trust in thee.**\n
            Send unto them help from above.\n
            **And evermore mightily defend them.**\n
            Help us, O God our Saviour.\n
            **And for the glory of thy Name deliver us; be merciful to us
            sinners, for thy Name's sake.**\n
            O Lord, hear our prayer.\n
            **And let our cry come unto thee.**"
            />

            <TextBlock
                content="Let us pray.\n\nO Lord, we beseech thee, mercifully hear our prayers, and
                spare all those who confess their sins unto thee; that they,
                whose consciences by sin are accused, by thy merciful pardon may
                be absolved; through Christ our Lord.\n**Amen.**"
            />

            <TextBlock
                content="O most mighty God, and merciful Father, who hast compassion upon
                all men, and hatest nothing that thou hast made; who wouldest
                not the death of a sinner, but that he should rather turn from
                his sin, and be saved: Mercifully forgive us our trespasses;
                receive and comfort us, who are grieved and wearied with the
                burden of our sins. Thy property is always to have mercy; to
                thee only it appertaineth to forgive sins. Spare us therefore,
                good Lord, spare thy people, whom thou hast redeemed; enter not
                into judgement with thy servants, who are vile earth, and
                miserable sinners; but so turn thine anger from us, who meekly
                acknowledge our vileness, and truly repent us of our faults, and
                so make haste to help us in this world, that we may ever live
                with thee in the world to come; through Jesus Christ our Lord.\n**Amen.**"
            />

            <Rubric content="The Officiant and People shall say together this prayer." />
            <TextBlock
                content="**Turn thou us, O good Lord, and so shall we be turned. Be
                    favourable, O Lord, Be favourable to thy people, Who turn to
                    thee in weeping, fasting, and praying. For thou art a
                    merciful God, Full of compassion. Longsuffering, and of
                    great pity. Thou sparest when we deserve punishment, And in
                    thy wrath thinkest upon mercy. Spare thy people, good Lord,
                    spare them, And let not thine heritage be brought to
                    confusion. Hear us, O Lord, for thy mercy is great, And
                    after the multitude of thy mercies look upon us; Through the
                    merits and mediation of thy blessed Son, Jesus Christ our
                    Lord. Amen.**"
            />

            <Rubric content="The Officiant shall pronounce this **Blessing.**" />
            <TextBlock
                content="The Lord bless us, and keep us; the Lord lift up the light of
                his countenance upon us, and give us peace, now and for
                evermore.\n**Amen.**"
            />
            <Spacer />
        </>
    );
};
